import { collection, query, where, limit, getDocs } from 'firebase/firestore';
import { db } from '@/lib/firestore';

export interface SubdomainContext {
  isCustomDomain: boolean;
  customDomain: string | null;
  consultantId: string | null;
}

const MAIN_DOMAINS = ['applywisely.in', 'www.applywisely.in', 'localhost', 'applywisely.lovable.app'];

export async function detectSubdomainContext(): Promise<SubdomainContext> {
  const hostname = window.location.hostname;

  if (MAIN_DOMAINS.includes(hostname)) {
    return { isCustomDomain: false, customDomain: null, consultantId: null };
  }

  // localhost with port — also treat as main domain
  if (hostname === 'localhost' || hostname.startsWith('127.') || hostname.startsWith('192.168.') || hostname.endsWith('.lovable.app') || hostname.endsWith('.lovableproject.com')) {
    return { isCustomDomain: false, customDomain: null, consultantId: null };
  }

  // Custom domain — look up which consultant it belongs to
  try {
    const q = query(
      collection(db, 'consultants'),
      where('whiteLabel.customDomain', '==', hostname),
      where('customDomainVerified', '==', true),
      limit(1),
    );
    const snap = await getDocs(q);

    if (snap.empty) {
      console.warn(`No verified consultant found for domain: ${hostname}`);
      return { isCustomDomain: true, customDomain: hostname, consultantId: null };
    }

    return {
      isCustomDomain: true,
      customDomain: hostname,
      consultantId: snap.docs[0].id,
    };
  } catch (err) {
    console.error('Subdomain detection failed:', err);
    return { isCustomDomain: true, customDomain: hostname, consultantId: null };
  }
}
